import React from "react";
import { render } from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { toast } from "react-toastify";

import Pusher from "pusher-js";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";
import { CedApplication, ModuleApplication } from "./applications";
import { ProofOfPayment, RegistrationPayment } from "./payments";

import { LeadPage, LeadProvider } from "./leads";
import {
	CreateProjectBudgetPage,
	CreateProjectPage,
	MyProjectsListPage,
	ProjectBudgetPage,
	ProjectBudgetProvider,
	ProjectDashboardPage,
	ProjectProvider,
	ProjectsBudgetTable,
	ProjectsTable,
} from "./projects";
import { PusherProvider } from "./PusherContext";
import { UserProvider } from "./users";

import "./sass/app.scss";

toast.configure();

if (process.env.NODE_ENV === "development") {
	Pusher.logToConsole = true;
}

const pusher = new Pusher("221b8a2bb25b172014d8", {
	cluster: "us2",
	encrypted: true,
});

const trackingId = "UA-59985052-1";
ReactGA.initialize(trackingId);

const options = {
	autoConfig: true,
	debug: false,
};
ReactPixel.init("1519846678097849", undefined, options);

export const App = () => {
	return (
		<PusherProvider pusher={pusher}>
			<UserProvider>
				<LeadProvider>
					<ProjectBudgetProvider>
						<ProjectProvider>
							<BrowserRouter>
								<Switch>
									<Route
										exact
										path="/accounts/:id"
										render={routeProps => (
											<>
												<ProjectsBudgetTable
													{...routeProps}
												/>
												<ProjectsTable
													{...routeProps}
												/>
											</>
										)}
									/>
									<Route
										exact
										path="/leads/:id"
										render={routeProps => (
											<>
												<LeadPage {...routeProps} />
											</>
										)}
									/>
									<Route
										exact
										path="/accounts/:id/create-project"
										component={CreateProjectPage}
									/>
									<Route
										exact
										path="/accounts/:id/create-project-budget"
										component={CreateProjectBudgetPage}
									/>
									<Route
										exact
										path="/projects/:id/:taskId?"
										component={ProjectDashboardPage}
									/>
									<Route
										exact
										path="/project-budget/:id"
										component={ProjectBudgetPage}
									/>
									<Route
										exact
										path="/my-projects"
										component={MyProjectsListPage}
									/>
									<Route
										exact
										path="/application/ced"
										component={CedApplication}
									/>
									<Route
										exact
										path="/application/module"
										component={ModuleApplication}
									/>
									<Route
										exact
										path="/application/submit-payment"
										component={ProofOfPayment}
									/>
									<Route
										exact
										path="/application/registration-fee"
										component={RegistrationPayment}
									/>
								</Switch>
							</BrowserRouter>
						</ProjectProvider>
					</ProjectBudgetProvider>
				</LeadProvider>
			</UserProvider>
		</PusherProvider>
	);
};

const root = document.getElementById("react-root");

if (root) {
	render(<App />, root);
}
